import { render, staticRenderFns } from "./AutoServiceCheckbox.vue?vue&type=template&id=8d3a1cca"
import script from "./AutoServiceCheckbox.vue?vue&type=script&lang=ts"
export * from "./AutoServiceCheckbox.vue?vue&type=script&lang=ts"
import style0 from "./AutoServiceCheckbox.vue?vue&type=style&index=0&id=8d3a1cca&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports